<nav class="nav flex-column">
    @for (item of menuItems; track $index) {
        <a class="nav-link active" [routerLink]="item.link" [ngClass]="{'active': item.active === true}">{{ item.label }}</a>
    }
</nav>
<router-outlet></router-outlet>
